<template>
  <div>
    <v-server-table @loaded="onLoaded" ref="table" :columns="columns" :url="url" :options="options">
      <div v-if="props.row.id" slot="nom_bal" slot-scope="props" class="">
        Mail n° {{ props.row.id }}<br>
        <span class="text-danger">{{ props.row.bal.nom }}</span>
      </div>
      <div v-if="props.row.date_reception_mail" slot="date_reception_mail" slot-scope="props" class="">
        {{ props.row.mail_from }}<br>
        <i class="text-primary">{{ formatDate(props.row.date_reception_mail) }}</i>
      </div>
      <div v-if="props.row.subject" slot="subject" slot-scope="props" class="">
        {{ props.row.subject }}
      </div>
      <div slot="message" slot-scope="props" class="">
        <span class="float-right"><b>{{ props.row.pieces_jointes.length }}<i class="fa fa-paperclip"></i></b></span>
        <span class="" v-if="props.row.body_text !== '0' && props.row.body_text !== ''">{{ props.row.body_text.substring(0,150) }}</span>
        <span class="" v-else>{{ props.row.body_html.substring(0,150) }}</span>

      </div>
      <div class="wrapper" slot="action" slot-scope="props">
        <router-link :to="getSrc(props.row)" class="badge badge-primary p-2"><i class="fa fa-search" title="Voir le mail"></i></router-link>
      </div>
      <div class="wrapper" slot="oag" slot-scope="props">
        {{ props.row.bal.oag.code }}
      </div>
      <div class="wrapper" slot="oap" slot-scope="props">
        {{ props.row.bal.oap.code }}
      </div>
      <div v-if="searchSpam" slot="h__checkbox">
        <b-form-checkbox
          v-model="allSelected"
          :indeterminate="indeterminate"
          aria-describedby="items"
          aria-controls="items"
          @change="toggleAll"
        >
        </b-form-checkbox>
      </div>
      <div v-if="searchSpam" class="wrapper" slot="checkbox" slot-scope="props">
        <b-form-checkbox
          v-model="selectedMails"
          :value="props.row.id"
        >
          
        </b-form-checkbox>
      </div>
      <div v-if="searchSpam" class="pull-right" slot="afterTable">
        <b-form-select style="width: 288px;display: inline-block;" v-model="selectedAction" class="">
          <b-form-select-option value="supprimer">Supprimer</b-form-select-option>
          <b-form-select-option value="non_spam">Non SPAM</b-form-select-option>
        </b-form-select>
        <b-button type="button" @click="manageAction()" class="ml-1" size="md"
                  variant="success">
          <i class="fa fa-save" title="Affecter les dossiers pour traitement"></i> Valider
        </b-button>
        <span class="field-error">{{ errors.action }}</span>
      </div>
    </v-server-table>
    
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken, getUser } from "@/utils/auth";
import { isEmpty } from '@/utils/fileHelper';

export default {
  name: "DecompteTable",
  props: ["tableEntry", 'searchSpam'],
  data() {
    let self = this;
    return {
      url: '',
      allSelected: false,
      indeterminate: false,
      selectedMails: [],
      selectedAction: '',
      columns: [
        "nom_bal",
        "date_reception_mail",
        "subject",
        "message",
        "oag",
        "oap",
        "action"
      ],
      options: {
        headings: {
          nom_bal: "Bal destination",
          date_reception_mail: "De",
          subject: "Objet",
          message: "Apperçu message",
          oag: "OAG",
          oap: "OAP",
          action: "#",
          checkbox: ''
        },
        columnsClasses: {
          nom_bal: "column-xs",
          date_reception_mail: "column-md",
          subject: "column-md",
          action: "action-xs"
        },
        rowClassCallback(row) {
          let rowClass = ''
          if (row.is_forwarded) { rowClass = 'mail-forwarded' }
          if (row.is_neutralised) { rowClass = 'mail-neutralised' }
          if (row.status_creation === 'En cours de qualification') { rowClass = 'mail-encours-qc' }
          if (row.status_creation === 'A affecter') { rowClass = 'mail-a-affecter' }
          if (row.status_creation === 'En cours de traitement') { rowClass = 'mail-encours-traitement' }
          if (row.status_creation === 'Traité') { rowClass = 'mail-traite' }
          return rowClass;
        },
        sortable: ["date_reception_mail"],
        orderBy: { column: "date_reception_mail", ascending: false },
        filterable: false,
        perPage: 10,
        perPageValues: [10, 25, 50],
        requestFunction: function (data) {
          self.url = '/espaceGestion/mail/recherche'
          data["mailFrom"] = self.tableEntry.from;
          data["mailId"] = self.tableEntry.mailId;
          data["text"] = self.tableEntry.text;
          data["nir"] = self.tableEntry.nir;
          data["dateDu"] = self.tableEntry.dateDu;
          data["dateAu"] = self.tableEntry.dateAu;
          data["noSearch"] = self.$parent.noSearch
          data["searchSpam"] = self.$parent.searchSpam
          data["bals"] = self.tableEntry.bals


          self.$store.commit("IS_LOADING", true);

          return axios.get(self.url, {
              params: data
          })
          .then(function (response) {
            self.$store.commit('IS_LOADING', false)
            self.$parent.resultStats = response.data.stats;
            // console.log('stats :',response.data.stats)
            self.searchData = data;
            return response;
          })
          .catch(function (e) {
            self.$store.commit("IS_LOADING", false);
            self.$swal({
              position: "top",
              type: "error",
              title: "Attention !!",
              text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
              showConfirmButton: false,
              timer: 5000
            });
          }.bind(this));
        }
      },
      errors: {
        action: '',
      }
    };
  },
  watch: {
    searchSpam() {
      if (this.searchSpam) {
        this.columns = ["nom_bal", "date_reception_mail", "subject", "message", "oag", "oap", "action", 'checkbox'];
      } else {
        this.columns = ["nom_bal", "date_reception_mail", "subject", "message", "oag", "oap", "action"];
      }
    },
    selectedMails(newVal, oldVal) {
      // Handle changes in individual checkboxes
      if (newVal.length === 0) {
        this.indeterminate = false
        this.allSelected = false
      } else if (newVal.length === this.$refs.table.data.length) {
        this.indeterminate = false
        this.allSelected = true
      } else {
        this.indeterminate = true
        this.allSelected = false
      }
    },
  },
  methods: {
    onLoaded(){
      this.$store.commit("IS_LOADING", false)
    },
    toggleAll(checked) {
      this.selectedMails = checked ? this.$refs.table.data.map(item => item.id) : []
    },
    getSrc(mail) {
      let user = getUser();
      let userOags = user.profil_active[0].oags.map(oag => oag.code);

      if (userOags.indexOf(mail.bal.oag.code) > -1) {
        return { path: "/espace-gestion/mail/show/" + mail.id, query: { mf: this.tableEntry.from, mi: this.tableEntry.mailId, text: this.tableEntry.text, nir: this.tableEntry.nir, dd: this.tableEntry.dateDu, da: this.tableEntry.dateAu, ss: this.tableEntry.searchSpam, bals: this.tableEntry.bals, page: this.$refs.table.page, limit: this.$refs.table.limit }}
      } else {
        return null;
      }
    },
    formatDate(textDate) {
      let date = textDate !== null ? new Date(textDate).toLocaleString("fr-FR") : "-";
      return date;
    },
    manageAction() {
      this.clearErrors();
      if (this.validateAction()) {
        if (this.selectedAction === 'supprimer') {
          let self = this;
          this.$swal.fire({
            title: 'Êtes-vous sûr?',
            text: 'Voulez-vous vraiment supprimer ce(s) mail(s) ?',
            type: 'warning',
            reverseButtons: true,
            showCancelButton: true,
            cancelButtonColor:"#ff1744",
            confirmButtonText: 'Annuler',
            cancelButtonText: 'Supprimer',
          }).then((result) => {
            if (result.value !== true) {
              let dataPost = {
                mailIds: this.selectedMails
              }
              this.$store.commit('IS_LOADING', true);
              this.$axios
                .post("/espaceGestion/mail/delete", dataPost)
                .then(response => {
                  this.$store.commit('IS_LOADING', false);
                  this.selectedMails = [];
                  this.$swal({ position: 'top', type: 'success', title:'Suppression avec succès', text:'Le(s) mail(s) ont bien été supprimé(s)',showConfirmButton: false, timer: 3000});
                  this.$refs['table'].refresh();
                })
                .catch(function(error){
                  console.log(error)
                  self.$store.commit('IS_LOADING', false)
                  let textError = 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI';
                  if (error.response && error.response.status === 424) {
                    textError = error.response.data.message;
                  }
                  self.$store.commit('IS_LOADING', false);
                  self.$swal({ position: 'top', type: 'warning', title:'Attention !!', text:textError, showConfirmButton: false, timer: 5000});
                  this.$refs['table'].refresh();
                })
            }
          })
        }

        if (this.selectedAction === 'non_spam') {
          let message = "Voulez-vous vraiment ré-activer ce(s) mail(s) ? Un dossier sera automatiquement créé par mail réactivé.";
          let textBoutonValide = "Ré-activer";
          this.$swal
            .fire({
              title: "Êtes-vous sûr?",
              text: message,
              type: "warning",
              reverseButtons: true,
              showCancelButton: true,
              allowOutsideClick: false,
              cancelButtonColor: "#ff1744",
              confirmButtonText: "Annuler",
              cancelButtonText: textBoutonValide
            })
            .then(result => {
              if (!result.value) {
                let self = this;
                let dataPost = {
                  mailIds: this.selectedMails
                }
                this.$store.commit("IS_LOADING", true);
                let mailId = this.id
                this.$axios
                  .post("/espaceGestion/mail/neutralise", dataPost)
                  .then(response => {
                    this.$store.commit("IS_LOADING", false);
                    // console.log(response.data)
                    this.selectedMails = [];
                    this.$refs['table'].refresh();
                  })
                  .catch(function(error) {
                    // console.log(error)
                    self.$store.commit("IS_LOADING", false);
                    self.$swal({
                      position: "top",
                      type: "error",
                      title: "Attention !!",
                      text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
                      showConfirmButton: false,
                      timer: 5000
                    })
                    this.$refs['table'].refresh();
                  })
              }
            })
        }
      }
    },
    validateAction() {
      let valid = true;

      if (isEmpty(this.selectedAction)) {
        valid = false;
        this.errors.action = 'Vous devez choisir une action.';
      }
      if (isEmpty(this.selectedMails)) {
        valid = false;
        this.errors.action = 'Vous devez sélectionner au moins un mail.';
      }

      return valid;
    },
    clearErrors() {
      this.errors.action = '';
    },
  }
};
</script>

<style scoped>
.VueTables__search-field input {
  width: 240px !important;
}

#list-decomptes-table .wrapper {
  text-align: center;
}
.smaller {
  font-size: 0.8em;
}
</style>
